import { render, staticRenderFns } from "./dictamen-emeritos-2026.vue?vue&type=template&id=e8df370c&scoped=true&"
import script from "./dictamen-emeritos-2026.component.ts?vue&type=script&lang=ts&"
export * from "./dictamen-emeritos-2026.component.ts?vue&type=script&lang=ts&"
import style0 from "./dictamen-emeritos-2026.vue?vue&type=style&index=0&id=e8df370c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8df370c",
  null
  
)

export default component.exports